import { hFetch } from '@/lib/hfetch';
import type { WorkflowTemplate, WorkflowTemplateKey } from './entity_types/workflow/WorkflowTemplate';
import type { WorkflowEntity } from './entity_types/workflow/Workflow';

export const listWorkflowTemplates = () => {
  return hFetch<WorkflowTemplate[]>({ url: '/api/workflow_templates' });
};

export const createFromTemplate = (key: WorkflowTemplateKey) => {
  return hFetch<WorkflowEntity, { key: WorkflowTemplateKey }>({
    url: '/api/workflow_templates',
    method: 'POST',
    payload: { key },
  });
};
